// Helper function to calculate time ago
export const timeAgo = (timestamp, currentTime) => {
  if (!timestamp) return '-';
  const now = currentTime;
  const time = new Date(timestamp);
  const diffInSeconds = Math.floor((now - time) / 1000);

  // if (diffInSeconds < 0) return "now";
  if (diffInSeconds < 10) return 'Live';
  if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
  return `${Math.floor(diffInSeconds / 86400)}d ago`;
};
